"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Explanations(props) {
  var explanations = props.explanations;


  return _react2.default.createElement(
    "div",
    { className: "area-max" },
    _react2.default.createElement(
      "div",
      { className: "container featureInfoBar", style: { marginBottom: 0 } },
      _react2.default.createElement(
        "div",
        { className: "container-child width-base" },
        _react2.default.createElement(
          "div",
          { className: "heading00" },
          _react2.default.createElement(
            "h2",
            { className: "title" },
            explanations.title
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "content00" },
          explanations.items.map(function (explanation) {
            return _react2.default.createElement(
              "div",
              { className: "pane-item", key: explanation.name },
              _react2.default.createElement(
                "div",
                { className: "media" },
                _react2.default.createElement(
                  "div",
                  { className: "media-object" },
                  _react2.default.createElement("i", { className: explanation.iconName })
                ),
                _react2.default.createElement(
                  "div",
                  { className: "media-head" },
                  _react2.default.createElement(
                    "h3",
                    null,
                    explanation.name
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: "media-body" },
                  _react2.default.createElement("p", { dangerouslySetInnerHTML: { __html: explanation.description } })
                )
              )
            );
          })
        )
      )
    )
  );
} // Explanations

Explanations.propTypes = {
  explanations: _react.PropTypes.object.isRequired
};

exports.default = Explanations;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/Explanations.js
// module id = 1199
// module chunks = 0